////////////////////////////////////////////////
// Define variables for project
////////////////////////////////////////////////
const vars = {};
vars.body = document.getElementsByTagName('body');
vars.title = document.querySelector('h1');

export { vars }